'use client';

import { useCallback, useState } from 'react';
import { DialogContextProvider, type DialogOptions, type DialogState } from '../../hooks/useDialog';

interface DialogProviderProps {
  children: React.ReactNode;
}

export function DialogProvider({ children }: DialogProviderProps) {
  const [dialogState, setDialogState] = useState<DialogState>({
    isOpen: false,
    title: '',
    message: '',
    confirmButtonText: '확인',
    onOpenChange: () => {},
  });

  const close = useCallback(() => {
    setDialogState((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, []);

  const open = useCallback(
    (options: DialogOptions) => {
      setDialogState({
        ...options,
        isOpen: true,
        onOpenChange: (open: boolean) => {
          if (!open) {
            close();
          }
        },
      });
    },
    [close],
  );

  const contextValue = {
    state: dialogState,
    open,
    close,
  };

  return <DialogContextProvider value={contextValue}>{children}</DialogContextProvider>;
}
